<form [formGroup]="form">
  <div class="card-inline full-width">
    <div>
      <p>
        <mat-form-field class="entity-width margin-right-small">
          <input
            type="text"
            #entity
            matInput
            placeholder="Entidad"
            (input)="onEntityChange()"
            formControlName="Entity"
            required
            [matAutocomplete]="autEntity"
          />
          <mat-autocomplete
            #autEntity="matAutocomplete"
            (optionSelected)="entitySelected($event.option.value)"
            [displayWith]="filterCompleteEntities.displayFn"
          >
            <mat-option
              *ngFor="let entity of filteredEntitiesOptions | async"
              [value]="entity"
            >
              {{ entity.Name }}
            </mat-option>
          </mat-autocomplete>
          <mat-error
            *ngIf="f.Entity.errors && f.Entity.errors.validAutoCompleteSelect"
          >
            Ingrese la entidad
          </mat-error>
        </mat-form-field>

        <mat-form-field class="margin-right-small">
          <input
            type="text"
            matInput
            placeholder="Plan"
            (input)="onPlanChange()"
            formControlName="Plan"
            [matAutocomplete]="autPlan"
            required
          />
          <mat-autocomplete
            #autPlan="matAutocomplete"
            (optionSelected)="planSelected()"
            [displayWith]="filterCompletePlans.displayFn"
          >
            <mat-option
              *ngFor="let plan of filteredPlansOptions | async"
              [value]="plan"
            >
              {{ plan.Name }}
            </mat-option>
          </mat-autocomplete>
          <mat-error
            *ngIf="f.Plan.errors && f.Plan.errors.validAutoCompleteSelect"
          >
            Ingrese el plan
          </mat-error>
        </mat-form-field>

        <button
          *ngIf="!this.isDisabled && !isAdmission && this.isRegistered"
          class="margin-right-small"
          (click)="editEntityInfo()"
          type="button"
          mat-mini-fab
        >
          <mat-icon>edit</mat-icon>
        </button>

        <button
          *ngIf="!isDisabled && !isRegistered"
          class="margin-right-small"
          matTooltip="Revalorizar"
          (click)="recalculate()"
          type="button"
          mat-mini-fab
        >
          <mat-icon>autorenew</mat-icon>
        </button>

        <mat-form-field
          formGroupName="Valorization"
          class="amount-column-width margin-left-small margin-right-small"
        >
          <input
            type="text"
            matInput
            placeholder="Tipo plan"
            (input)="onAliquotTaxChange()"
            formControlName="AliquotTax"
            [matAutocomplete]="autAliquotTax"
            required
          />
          <mat-autocomplete
            #autAliquotTax="matAutocomplete"
            (optionSelected)="aliquotTaxSelected($event.option.value)"
            [displayWith]="filterCompleteAliquotsTax.displayFn"
          >
            <mat-option
              *ngFor="let aliquotTax of filteredAliquotsTaxOptions | async"
              [value]="aliquotTax"
            >
              {{ aliquotTax.Name }}
            </mat-option>
          </mat-autocomplete>
          <mat-error
            *ngIf="
              fValorization.AliquotTax.errors &&
              fValorization.AliquotTax.errors.validAutoCompleteSelect
            "
          >
            Ingrese el tipo de plan
          </mat-error>
        </mat-form-field>
        <mat-form-field
          *ngIf="!isDisabled"
          class="practice-width margin-right-small"
        >
          <input
            type="text"
            (input)="onPracticeRegionAddChange()"
            matInput
            class="practice-width"
            placeholder="Nueva práctica"
            formControlName="PracticeRegionAdd"
            [matAutocomplete]="autPracticeRegionAdd"
          />
          <mat-autocomplete
            (optionSelected)="apacticeRegionAddSelected($event.option.value)"
            #autPracticeRegionAdd="matAutocomplete"
            [displayWith]="displayPosiblePracticesFn"
          >
            <mat-option
              *ngFor="let practice of filterCompletePosiblePractices | async"
              [value]="practice"
            >
              {{ practice.Name }}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
        <mat-form-field *ngIf="!isDisabled" class="amount-column-width">
          <input
            type="number"
            matInput
            class="amount-column-width"
            placeholder="Cantidad"
            formControlName="PracticeRegionQuantityAdd"
          />
        </mat-form-field>

        <button
          type="button"
          *ngIf="!isDisabled && !isRegistered"
          (click)="add()"
          mat-mini-fab
        >
          <mat-icon>add</mat-icon>
        </button>
      </p>

      <div style="overflow-y: scroll; overflow-x: scroll; max-height: 300px">
        <mat-spinner *ngIf="loading"></mat-spinner>
        <table
          *ngIf="!loading"
          mat-table
          class="search-table"
          [dataSource]="valorizationItemsDataSource"
          formArrayName="ValorizationItemsAmount"
        >
          <tr
            mat-header-row
            class="search-table-header"
            *matHeaderRowDef="
              seeAmounts
                ? displayAllValorizationItemsColumns
                : displayNoAmountValorizationItemsColumns;
              sticky: true
            "
          ></tr>
          <tr
            mat-row
            class="search-table-cell"
            *matRowDef="
              let row;
              let i = index;
              columns: seeAmounts
                ? displayAllValorizationItemsColumns
                : displayNoAmountValorizationItemsColumns
            "
          ></tr>

          <ng-container matColumnDef="practiceName">
            <th mat-header-cell class="table-header" *matHeaderCellDef>
              Práctica
            </th>
            <td
              mat-cell
              class="search-table-cell"
              *matCellDef="let row; let index = index"
              [formGroupName]="index"
            >
              <div>
                <b>{{ displayPracticeName(index) }}</b>
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="quantity">
            <th mat-header-cell class="table-header" *matHeaderCellDef>
              Cantidad
            </th>
            <td
              mat-cell
              class="search-table-cell"
              *matCellDef="let row; let index = index"
              [formGroupName]="index"
            >
              <div>{{ displayQuantity(index) }}</div>
            </td>
          </ng-container>

          <ng-container *ngIf="seeAmounts" matColumnDef="feeAmount">
            <th mat-header-cell class="table-header" *matHeaderCellDef>$Hon</th>
            <td
              mat-cell
              class="search-table-cell"
              *matCellDef="let row; let index = index"
              [formGroupName]="index"
            >
              <div>{{ displayFeeAmount(index) }}</div>
            </td>
          </ng-container>

          <ng-container matColumnDef="feeCoverage">
            <th mat-header-cell class="table-header" *matHeaderCellDef>%Hon</th>
            <td
              mat-cell
              class="search-table-cell"
              *matCellDef="let row; let index = index"
              [formGroupName]="index"
            >
              <div>{{ displayFeeCoverage(index) }}</div>
            </td>
          </ng-container>

          <ng-container *ngIf="seeAmounts" matColumnDef="rightsAmount">
            <th mat-header-cell class="table-header" *matHeaderCellDef>$Der</th>
            <td
              mat-cell
              class="search-table-cell"
              *matCellDef="let row; let index = index"
              [formGroupName]="index"
            >
              <div>{{ displayRightsAmount(index) }}</div>
            </td>
          </ng-container>

          <ng-container matColumnDef="rightsCoverage">
            <th mat-header-cell class="table-header" *matHeaderCellDef>%Der</th>
            <td
              mat-cell
              class="search-table-cell"
              *matCellDef="let row; let index = index"
              [formGroupName]="index"
            >
              <div>{{ displayRightsCoverage(index) }}</div>
            </td>
          </ng-container>

          <ng-container *ngIf="seeAmounts" matColumnDef="moduleAmount">
            <th mat-header-cell class="table-header" *matHeaderCellDef>$Mod</th>
            <td
              mat-cell
              class="search-table-cell"
              *matCellDef="let row; let index = index"
              [formGroupName]="index"
            >
              <div>{{ displayModuleAmount(index) }}</div>
            </td>
          </ng-container>

          <ng-container matColumnDef="moduleCoverage">
            <th mat-header-cell class="table-header" *matHeaderCellDef>%Mod</th>
            <td
              mat-cell
              class="search-table-cell"
              *matCellDef="let row; let index = index"
              [formGroupName]="index"
            >
              <div>{{ displayModuleCoverage(index) }}</div>
            </td>
          </ng-container>

          <ng-container *ngIf="seeAmounts" matColumnDef="supplieAmount">
            <th mat-header-cell class="table-header" *matHeaderCellDef>$Ins</th>
            <td
              mat-cell
              class="search-table-cell"
              *matCellDef="let row; let index = index"
              [formGroupName]="index"
            >
              <div>{{ displaySupplieAmount(index) }}</div>
            </td>
          </ng-container>

          <ng-container matColumnDef="supplieCoverage">
            <th
              mat-header-cell
              class="search-table-header resizable-column"
              *matHeaderCellDef
            >
              <resizable-column-control
                width="50"
                tile="%Ins"
              ></resizable-column-control>
            </th>
            <td
              mat-cell
              class="search-table-cell"
              *matCellDef="let row; let index = index"
              [formGroupName]="index"
            >
              <div>{{ displaySupplieCoverage(index) }}</div>
            </td>
          </ng-container>

          <ng-container *ngIf="seeAmounts" matColumnDef="assuranceAmount">
            <th mat-header-cell class="table-header" *matHeaderCellDef>
              Coseguro
            </th>
            <td
              mat-cell
              class="search-table-cell"
              *matCellDef="let row; let index = index"
              [formGroupName]="index"
            >
              <div>{{ displayAssuranceAmount(index) }}</div>
            </td>
          </ng-container>

          <ng-container *ngIf="seeAmounts" matColumnDef="totalAmount">
            <th mat-header-cell class="table-header" *matHeaderCellDef>
              Total
            </th>
            <td
              mat-cell
              class="search-table-cell"
              *matCellDef="let row; let index = index"
              [formGroupName]="index"
            >
              <div>{{ displayTotalAmount(index) }}</div>
            </td>
          </ng-container>

          <ng-container *ngIf="seeAmounts" matColumnDef="patientAmountWithTax">
            <th mat-header-cell class="table-header" *matHeaderCellDef>
              Total Pac c/iva
            </th>
            <td
              mat-cell
              class="search-table-cell"
              *matCellDef="let row; let index = index"
              [formGroupName]="index"
            >
              <div>{{ displayPatientAmountWithTax(index) }}</div>
            </td>
          </ng-container>

          <ng-container *ngIf="seeAmounts" matColumnDef="entityAmountWithTax">
            <th mat-header-cell class="table-header" *matHeaderCellDef>
              Total Os c/iva
            </th>
            <td
              mat-cell
              class="search-table-cell"
              *matCellDef="let row; let index = index"
              [formGroupName]="index"
            >
              <div>{{ displayEntityAmountWithTax(index) }}</div>
            </td>
          </ng-container>

          <ng-container matColumnDef="star">
            <th
              mat-header-cell
              class="search-table-header"
              *matHeaderCellDef
            ></th>
            <td
              mat-cell
              class="search-table-cell"
              *matCellDef="let row; let index = index"
              [formGroupName]="index"
            >
              <div class="card-inline">
                <button
                  *ngIf="canEdit(index)"
                  type="button"
                  (click)="edit(index)"
                  mat-icon-button
                >
                  <mat-icon>edit</mat-icon>
                </button>

                <button
                  *ngIf="canAddSetInsumo(index)"
                  type="button"
                  (click)="addSetInsumo(index)"
                  mat-icon-button
                >
                  <mat-icon>add</mat-icon>
                </button>
              </div>
            </td>
          </ng-container>
        </table>
      </div>
    </div>
  </div>
  <div *ngIf="isAdmission">
    <span><b>Total Pac c/iva: </b>{{ patientAmount() }}</span>
  </div>
</form>
